module.exports = __webpack_public_path__ + "img/img_none_sj.bc44eb28.webp";